import { FunctionComponent } from 'react';
import classnames from 'classnames';

import LayoutContainer from 'components/layout/LayoutContainer';

import { Props } from './index';
import StyledComponent from './styles';


const PublicLayoutJobsCityFilters: FunctionComponent<Props> = ({
    title,
    cities,
    layoutContainerProps,
    searchParams,
    onChangeSearchParam,
}) => {
    return (
        <StyledComponent className="public-layout-jobs-city-filters">
            <LayoutContainer {...layoutContainerProps}>
                <div className="copy">
                    {title && (
                        <h2
                            className="headline"
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                    )}
                </div>

                {Array.isArray(cities) && cities.length > 0 && (
                    <div className="cities-list">
                        {cities.map(element => (
                            <button
                                key={element.id}
                                className={classnames(
                                    'city',
                                    { 'active': element.slug === searchParams.city.getQueryValue() }
                                )}
                                onClick={() => {
                                    if( element.slug === searchParams.city.getQueryValue() ) {
                                        onChangeSearchParam('city', null, true);
                                    } else {
                                        onChangeSearchParam('city', element);
                                    }
                                }}
                            >
                                {element.name}
                            </button>
                        ))}
                    </div>
                )}

                {/*  {activeCity && Array.isArray(activeCity?.districts) && activeCity?.districts.length > 0 && (
                    <div className="districts-list">
                        {activeCity?.districts.map(element => (
                            <a
                                key={element.id}
                                className={classnames(
                                    'commune',
                                    { 'active': element.slug === activeCityDistrict?.slug })}
                                onClick={() => {
                                    if(element.slug === activeCityDistrict?.slug) {
                                        onChangeSearchParams({ districtSlug: null });
                                    } else {
                                        onChangeSearchParams({ districtSlug: element.slug });
                                    }
                                }}
                            >
                                {element.name} ({element.jobsCount})
                            </a>
                        ))}
                    </div>
                )} */}

            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutJobsCityFilters;